import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { ConfigurationStatus, ConfigurationType } from '../../../../../domain/consts';
import { Offer } from '../../../../../domain/offer.domain';
import {
    InsuredProductMotor,
    MotorConfiguration,
    MotorConfigurationStep,
    VehicleDefinitionMode
} from '../../../../../domain/product.domain';
import { OfferAction } from '../../../store/offer.action';

@Component({
    selector: 'app-motor-box',
    templateUrl: './motor-box.component.html',
    styleUrls: ['./motor-box.component.scss']
})
export class MotorBoxComponent {

    @Input() offer: Offer;
    @Input() readonly = false;
    vehicleDefinitionMode = VehicleDefinitionMode;

    constructor(private store: Store, private translateService: TranslateService) {
    }

    get insuranceScope() {
        const configuration = this.configuration;
        const result = [
            {label: 'MOTOR_CONFIG.INSURANCE_SCOPE_OC', available: configuration.thirdPartyLiability.selected},
            {label: 'MOTOR_CONFIG.INSURANCE_SCOPE_AC', available: configuration.autocasco.selected},
            {label: 'MOTOR_CONFIG.ADDON_NNW', available: configuration.accidentInsurance.selected},
            {label: 'MOTOR_CONFIG.ADDON_ASSSTANCE', available: configuration.motorAssistance.selected},
        ];
        return result
            .filter(element => element.available)
            .map(element => this.translateService.instant(element.label))
            .join(', ');
    }


    get product() {
        return this.offer.productList
            .find(p => p.configuration.configurationType === ConfigurationType.MOTOR) as InsuredProductMotor;
    }

    get productId(): number {
        const product = this.product;
        if (product) {
            return product.id;
        }
        return null;
    }

    get configuration(): MotorConfiguration {
        return this.offer.productList
            .map(p => p.configuration)
            .find(p => p.configurationType === ConfigurationType.MOTOR) as MotorConfiguration;
    }

    get hasFinishedConfiguration() {
        if (!this.configuration) {
            return false;
        }
        return this.configuration.configurationStatus === ConfigurationStatus.COMPLETED;
    }

    get hasErrors() {
        if (!this.configuration) {
            return false;
        }
        return this.configuration.configurationStep === MotorConfigurationStep.DETAILS
            && this.configuration.configurationStatus === ConfigurationStatus.ERRORS;
    }

    configure() {
        this.store.dispatch(new OfferAction.CreateProductMotor(this.offer.id));
    }

    delete() {
        if (this.productId) {
            this.store.dispatch(new OfferAction.DeleteProduct(this.offer.id, this.productId));
        }
    }

    preview() {
        this.store.dispatch(new OfferAction.ReadonlyMotor(this.product));
    }
}
